/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import { ExtendedOption } from "components/common/Select/Base";
import { PALETTE } from "styles/base/variables";

interface OptionBoxProps {
  isOpen: boolean;
  minWidth?: number;
  maxHeight?: number;
  name: string;
  color?: string;
  options: ExtendedOption[];
  clickOption: (e: React.MouseEvent<HTMLOptionElement>) => void;
}

function OptionBox({
  isOpen,
  minWidth,
  maxHeight,
  name,
  color = PALETTE.text,
  options,
  clickOption,
}: OptionBoxProps) {
  return (
    <div
      id="select-option--container"
      css={css`
        ${minWidth ? `min-width: ${minWidth - 2}px;` : ""}
        ${maxHeight ? `max-height: ${maxHeight}px;` : ""}
        overflow-y: auto;
        padding: 8px 0;
        position: absolute;
        position-anchor: --select-button-${name};
        z-index: 20;
        display: ${isOpen ? "block" : "none"};
        background-color: ${PALETTE.light};
        border-radius: 4px;
        box-shadow: 0px 2px 2px 0px #00000033;
      `}
    >
      {options.map((option) => {
        return (
          <option
            css={css`
              cursor: pointer;
              padding: 10px 14px;
              font-size: 14px;

              &:hover {
                background-color: ${PALETTE.background};
                color: ${color};
              }
            `}
            key={option.value}
            value={option.value}
            onClick={clickOption}
          >
            {option.label}
          </option>
        );
      })}
    </div>
  );
}

export default OptionBox;
